import PropTypes from "prop-types";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import {
  default as logo,
  default as logoDark,
  default as logoLightPng,
} from "../../assets/images/logo1.png";
import logoLightSvg from "../../assets/images/logo2.png";
import SidebarContent from "./SidebarContent";

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="17" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img
                src={logoLightSvg}
                alt=""
                height="22"
                style={{ marginLeft: "18px" }}
              />
            </span>
            <span className="logo-lg">
              <img
                style={{
                  transform: "scale(0.5)",
                  marginLeft: "-55px",
                }}
                src={logoLightPng}
                alt=""
                height="90"
              />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

export default withRouter(Sidebar);

// const mapStatetoProps = state => {
//   return {
//     layout: state.Layout,
//   };
// };
// export default connect(
//   mapStatetoProps,
//   {}
// )(withRouter(withTranslation()(Sidebar)));
